import React, { useEffect, useState } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import MainButton from "../../../../components/main-button";
import LeftInfoModal from "../../../../components/left-info-modal";
import Loader from "../../../../components/loader";
import { images } from "../../../../assets";

import SigningServices from "../../../../services/SigningServices";
import { RESPONSE_SIGNIG_STATUS, SIGNIG_STATUS } from "../../new-hiring/types";
import { LeftInfoModalProps } from "../../../../components/left-info-modal/left-info-modal-layout";

interface ResendSignatureButtonProps extends RouteComponentProps {
  hiring: {
    signatureStatus: string;
    body: {
      signData?: {
        signId?: string;
      };
    };
  };
}

const ResendSignatureButton: React.FC<ResendSignatureButtonProps> = ({ hiring, history }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [modal, setModal] = useState<Partial<LeftInfoModalProps> | null>(null);
  const [canResendSignature, setCanResendSignature] = useState<boolean>(false);

  useEffect(() => {
    const policySignatureStatus = hiring && hiring.signatureStatus;
    if (policySignatureStatus !== SIGNIG_STATUS.SOLICITADA) {
      setCanResendSignature(false);
      return;
    }

    const checkSignStatus = async () => {
      const signId = hiring && hiring.body && hiring.body.signData && hiring.body.signData.signId;
      if (signId) {
        const signStatusResponse = await SigningServices.getSignRequest(setLoading, true, signId);
        setCanResendSignature(signStatusResponse.status === RESPONSE_SIGNIG_STATUS.REQUESTED);
      } else {
        setCanResendSignature(false);
      }
    };

    void checkSignStatus();
  }, [hiring]);

  const showResendSignatureDialog = () => {
    setModal({
      active: true,
      className: "info",
      img: images.IconCheckGreen2,
      mainTitle: "Reenvío de firma",
      mainText: "¿Deseas reenviar el documento de firma al asegurado?",
      buttonText: "Reenviar",
      noSecondaryButton: false,
      hasAcceptNoClose: true,
      onClickAccept: function () {
        setModal(null);
        void resendSignature()
      },
    });
  };

  const resendSignature = async () => {
    const signId = hiring && hiring.body && hiring.body.signData && hiring.body.signData.signId;
    if (!signId) {
      setModal( {
        active: true,
        className: "error",
        img: images.WarningError,
        mainTitle: "Error de identificador de firma",
        mainText:"No existe un identificador de firma para reenviar la solicitud",
        buttonText: "Cerrar",
        noSecondaryButton: true,
      });
      return;
    }
    
    setLoading(true);
    const response = await SigningServices.resendSignRequest({
      setLoading: () => {},
      loader: false,
      signId,
    });

    if (response.ok) {
      setModal({
        active: true,
        className: "info",
        img: images.IconCheckGreen2,
        mainTitle: "Firma reenviada",
        mainText: "El documento de firma ha sido reenviado correctamente al asegurado.",
        buttonText: "Aceptar",
        noSecondaryButton: true,
        onClickAccept: () => {
          history.push("/contratacion/pendiente");
        },
      });
    } else {
      setModal({
        active: true,
        className: "error",
        img: images.WarningError,
        mainTitle: "Error al reenviar firma",
        mainText:
          response.message ||
          "No fue posible reenviar el documento. Por favor, intenta de nuevo más tarde.",
        buttonText: "Cerrar",
        noSecondaryButton: true,
      });
    }
    setLoading(false);
  };

  if (!canResendSignature) {
    return null;
  }

  return (
    <>
      {loading && <Loader />}
      <MainButton text="Reenvío firma" onClick={showResendSignatureDialog} />
      {modal && (
        <LeftInfoModal
          img={modal.img}
          className={modal.className}
          mainTitle={modal.mainTitle}
          mainText={modal.mainText}
          buttonText={modal.buttonText}
          close={() => setModal(null)}
          active={modal.active}
          onClickAccept={modal.onClickAccept}
          noSecondaryButton={modal.noSecondaryButton}
          hasAcceptNoClose={modal.hasAcceptNoClose || false}
        />
      )}
    </>
  );
};

export default withRouter(ResendSignatureButton);
